import React from 'react'
import './App.css'
import Application from './pages/App'
import './App.css'

function App() {
  return <Application />
}

export default App